import React from "react";
import { Box, Container, Typography, Rating, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const feedbacks = [
  {
    quote: `I really enjoyed the online class. I thought it was well planned and layed out easy for me to follow.\nIt is useful for me to learn English. Thank you TIET for giving this opportunity.`,
    user: "R Nithima",
  },
  {
    quote: `Our Mentor is very sweet and kind, making learning a pleasure. Ma'am patiently clears all doubts, ensuring a thorough understanding.\nI am very happy to give this feedback that I learned a lot of new things here. I am praying for your good health and wealth.\nYour contribution is priceless. Thank you so much!\nFirst of all, I would like to thank our TIET. I highly recommend this course.`,
    user: "P. Preethi",
  },

  {
    quote: `She explained very well and politely. It is very useful in our daily life.\nWe are heartfully thankful to our TIET MANAGEMENT. May Allah reward you with Jannah.`,
    user: "Maseeha Parveen S",
  },
  {
    quote: `I liked the spoken English class. The teacher was good and explained everything clearly.\nI feel more confident now while speaking.\nI would like to suggest offering an advanced level course for those who have completed this one.`,
    user: "Y Uzma Tabassum",
  },
  {
    quote: `It helped us to improve our communication skills.\nI learned grammar parts which I didn't know. This class enhanced our vocabulary and pronunciation as well.\nHelpful platform. Keep rocking TIET !!.`,
    user: "Mashooda B",
  },
  {
    quote: `Firstly, I'd like to extend heartfelt thanks to Our Mentor and the TIET team.\nI'm extremely happy to share my feedback today. This English course has been incredibly useful.\nInitially, I lacked confidence in speaking, but now, Alhamdulillah, I've improved a lot.\nThe activity-based sessions made learning very effective.\nThank you so much once again!`,
    user: "Thasleem Banu A",
  },
  {
    quote: `This online class has been incredibly informative and engaging for me.\nI truly appreciate the effort of the TIET!.`,
    user: "K Fathima Sultana",
  },
];

const OnlineCertificateForTeachers = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate(-1);

  return (
    <>
      {/* Certificate Distribution Heading and Intro */}
      <Box p={8} px={{ xs: 0, md: 8 }}>
        <Container>
          <IconButton onClick={handleBack} sx={{ mb: 3 }}>
            <ArrowBack fontSize="large" />
          </IconButton>

          <Typography
            variant="h5"
            fontWeight="bold"
            gutterBottom
            align="center"
          >
            Online Certificate Program – Spoken English for Teachers
          </Typography>

          <Typography variant="body1" align="justify">
            <br />
            🌟 <strong>
              TIET – A Proud Milestone in Teacher Empowerment!
            </strong>{" "}
            🌟
            <br />
            <br />
            On <strong>Sunday, 22nd June 2025</strong>, we successfully held the{" "}
            <strong>Online Certificate Distribution Program</strong> for the{" "}
            <strong>Spoken English Course</strong>, specially designed for
            school teachers.
            <br />
            <br />
            Led by{" "}
            <strong>Prof. Mrs. M. A. Uzefa Rashida (M.A., B.Ed., SET)</strong>,
            Core Member, TIET Women's Wing, and guided by our dedicated tutor{" "}
            <strong>Mrs. Najeeba Umar (M.A., B.Ed., M.Phil.)</strong>, this
            program helped educators strengthen their communication skills and
            boost classroom confidence.
            <br />
            <br />
            📚 A heartfelt thank you to the management of the four participating
            schools —{" "}
            <strong>
              Al Falah School, Al Hilal Primary School, Green Valley School,
            </strong>{" "}
            and <strong>Mohammediya Primary School</strong> — for their constant
            support and encouragement.
            <br />
            <br />
            Because of their collaboration, <strong>
              59 women teachers
            </strong>{" "}
            benefited from this initiative.
            <br />
            <br />
            💬 “When you empower a teacher, you empower an entire generation.”
            <br />
            💬 “Education is the most powerful tool we can use to change the
            world — and our teachers are the ones who carry that tool every
            day.”
            <br />
            <br />
            🎓 During the closing ceremony, TIET proudly awarded eCertificates
            to all successful participants. The event was a celebration of
            learning, growth, and the unwavering spirit of our educators.
            <br />
            <br />
            A big congratulations to all the learners!
            <br />
            <br />
            We are truly inspired by the enthusiasm and commitment shown by each
            participant. May this be the beginning of many more achievements
            ahead, InshaAllah!
            <br />
            <br />
            Regards,
            <br />
            <strong>TIET Women's Wing</strong>
          </Typography>
        </Container>
      </Box>

      {/* Feedback/Success Stories Section */}
      <Box p={8} px={{ xs: 0, md: 8 }}>
        <Container>
          <Typography
            variant="h5"
            fontWeight="bold"
            gutterBottom
            align="center"
          >
            Success Stories
          </Typography>

          {feedbacks.map((story, index) => (
            <Box
              key={index}
              p={4}
              my={2}
              textAlign="center"
              borderRadius={2}
              sx={{
                backgroundColor: index % 2 === 0 ? "#f5f5f5" : "#ffffff",
              }}
            >
              <Typography
                variant="body1"
                fontStyle="italic"
                whiteSpace="pre-line"
              >
                {story.quote}
              </Typography>
              <Rating name="rating" value={5} readOnly sx={{ my: 1 }} />
              <Typography variant="subtitle1" fontWeight="bold">
                {story.user}
              </Typography>
            </Box>
          ))}
        </Container>
      </Box>
    </>
  );
};

export default OnlineCertificateForTeachers;
